import ProfilePage from './ProfilePageContainer';

export default ProfilePage;
